import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { DripCampaignTemplate, DripCampaignStep } from '@app/_models/drip-campaign';
import { SharedService } from '@app/_components/_shared/shared.service';

@Injectable({ providedIn: 'root' })
export class DripCampaignTemplateService {

  private readonly templateBase = `${environment.apiUrl}/drip/templates`;
  private readonly stepBase = `${environment.apiUrl}/drip/steps`;

  constructor(
    private http: HttpClient,
    private sharedService: SharedService
  ) {}

  findAll(page: number, size: number, sortField: any, sortOrder: any, multiSortMeta: any, globalFilter: any, filters: any): Observable<any> {
    const params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortField, sortOrder, multiSortMeta, globalFilter, filters);
    return this.http.get<any>(this.templateBase, { params });
  }

  findById(id: number): Observable<DripCampaignTemplate> {
    return this.http.get<any>(`${this.templateBase}/${id}`).pipe(
      map((res: any) => res?.data?.dripCampaignTemplate as DripCampaignTemplate)
    );
  }

  save(template: DripCampaignTemplate): Observable<DripCampaignTemplate> {
    return this.http.post<any>(this.templateBase, template).pipe(
      map((res: any) => res?.data?.dripCampaignTemplate as DripCampaignTemplate)
    );
  }

  update(template: DripCampaignTemplate): Observable<DripCampaignTemplate> {
    return this.http.patch<any>(this.templateBase, template).pipe(
      map((res: any) => res?.data?.dripCampaignTemplate as DripCampaignTemplate)
    );
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.templateBase}/${id}`);
  }

  findStepsByTemplateId(templateId: number): Observable<DripCampaignStep[]> {
    const params = new HttpParams()
      .set('dripCampaignTemplateId', templateId)
      .set('size', '200')
      .set('sort', 'stepOrder,asc');
    return this.http.get<any>(this.stepBase, { params }).pipe(
      map((res: any) => (res?.data?.dripCampaignSteps ?? []) as DripCampaignStep[])
    );
  }

  saveStep(step: DripCampaignStep): Observable<DripCampaignStep> {
    return this.http.post<any>(this.stepBase, step).pipe(
      map((res: any) => res?.data?.dripCampaignStep as DripCampaignStep)
    );
  }

  updateStep(step: DripCampaignStep): Observable<DripCampaignStep> {
    return this.http.patch<any>(this.stepBase, step).pipe(
      map((res: any) => res?.data?.dripCampaignStep as DripCampaignStep)
    );
  }

  deleteStep(stepId: number): Observable<any> {
    return this.http.delete<any>(`${this.stepBase}/${stepId}`);
  }
}
